import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    checkbox: {
        padding: 5
    }
}));

export default useStyles;
